import { Injectable } from '@angular/core';
import { User } from '../../../../common/models/user';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { AuthState, AuthStateModel } from 'src/app/state/auth/auth.state';
import { Store } from '@ngxs/store';
import { ClearAuthState, SetAuthTokenData, SetSettingsData, SetUserData, SetUserName } from 'src/app/state/auth/auth.actions';
import { Observable } from 'rxjs';
import { AuthToken } from 'src/app/common/models/auth-token';
import { Settings } from 'src/app/common/models/settings';

@Injectable({
    providedIn: 'root'
})

export class UserService {

    @SelectSnapshot(AuthState.getAuthState) authStateSnapshot: AuthStateModel | null;

    constructor(private readonly store: Store) {}

    getUser(): User {
        return this.authStateSnapshot.user;
    }

    setUser(user: User): Observable<User> {
        return this.store.dispatch(new SetUserData(user));
    }

    setUserName(name: string): Observable<string> {
        return this.store.dispatch(new SetUserName(name));
    }

    getSettings(): Settings {
        return this.authStateSnapshot.settings;
    }

    setSettings(settings: Settings): Observable<User> {
        return this.store.dispatch(new SetSettingsData(settings));
    }

    getAuthToken(): AuthToken {
        return this.authStateSnapshot.token;
    }

    setAuthToken(token: AuthToken): Observable<AuthToken> {
        return this.store.dispatch(new SetAuthTokenData(token));
    }

    userHasRole(role: string) {
        const user = this.authStateSnapshot.user;

        if (user && user?.roles?.includes(role)) {
            return true;
        }

        return false;
    }

    getName(decodedToken: any) {
        let name = [decodedToken?.firstName, decodedToken?.lastName].join(' ')?.trim();

        if (!name) {
            name = decodedToken?.name;
        }

        return name;
    }

    clearAuthState() {
        return this.store.dispatch(new ClearAuthState());
    }
}
